var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticStyle: { overflow: "hidden" } }, [
    _c(
      "table",
      {
        staticClass: "ivu-table-summary",
        style: _vm.styleObject,
        attrs: { cellspacing: "0", cellpadding: "0", border: "0" }
      },
      [
        _c(
          "colgroup",
          _vm._l(_vm.columns, function(column, index) {
            return _c("col", { attrs: { width: _vm.setCellWidth(column) } })
          }),
          0
        ),
        _vm._v(" "),
        _c("tbody", { class: [_vm.prefixCls + "-tbody"] }, [
          _c(
            "tr",
            { staticClass: "ivu-table-row" },
            _vm._l(_vm.columns, function(column, index) {
              return _c("td", { class: _vm.alignCls(column) }, [
                _c(
                  "div",
                  { staticClass: "ivu-table-cell", class: _vm.cellCls(column) },
                  [_c("span", [_vm._v(_vm._s(_vm.data[column.key].value))])]
                )
              ])
            }),
            0
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17eff8bb", { render: render, staticRenderFns: staticRenderFns })
  }
}